import React from 'react';

interface AbstractToggleProps {
  onChange?: (value: boolean) => void;
  checked?: boolean;
  id: string;
}

export default class AbstractToggle extends React.PureComponent<AbstractToggleProps> {

  static defaultProps = {
    onChange: () => {}
  };

  onChange = () => {
    const { onChange, checked } = this.props;
    onChange && onChange(!checked);
  };
}